import React from 'react';

import { generateKey } from 'Helpers/misc';

export default function DashboardReachAwareness(props) {
    return (
        <div className="card border-0 rounded-15px bg-white shadow h-100 px-3">
            <div className="card-body card-widget">
                <div className={'row'}>
                    <div className={'col'}>
                        <h2 className="text-dark-blue">{$t('Reach & Awareness')}</h2>
                    </div>
                </div>
                <div className={'row'}>
                    <div className={'col'}>
                        <div className={'row my-3'}>
                            <div className={'col-12 col-lg-4'}>
                                <div style={{ overflowX: 'auto' }}>
                                    <table className={'my-3 key-metrics-table table table-borderless table-sm no-footer'}>
                                        <tbody>
                                            <tr className="text-blue bg-white">
                                                <th colSpan={2}>{$t('Social Reach')}</th>
                                            </tr>
                                            {props.data.social_reach.map((row) => {
                                                const key = Object.keys(row)[0];

                                                return (
                                                    <tr className="bg-white" key={generateKey()}>
                                                        <td className={'text-gray'}>
                                                            {key} {$t('Reach')}
                                                        </td>
                                                        <td className={'font-weight-bold text-right text-blue'}>{props.format(row[key])}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className={'col-12 col-lg-8'}>
                                <div className={'row h-100 align-items-start'}>
                                    <div className={'col-12 col-lg-6'}>
                                        <div className="card border-0 rounded-15px bg-white shadow">
                                            <div className="card-body card-widget">
                                                <div className={'d-flex flex-column justify-content-center h-100 p-3'}>
                                                    <h4 className={'text-blue mb-2'}>{$t('International Federations')}</h4>
                                                    <h3 className={'text-blue'}>{props.format(props.data.international_federations)}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'col-12 col-lg-6'}>
                                        <div className="card border-0 rounded-15px bg-white shadow">
                                            <div className="card-body card-widget">
                                                <div className={'d-flex flex-column justify-content-center h-100 p-3'}>
                                                    <h4 className={'text-blue mb-2'}>{$t('National Olympic Committees')}</h4>
                                                    <h3 className={'text-blue'}>{props.format(props.data.national_olympic_committees)}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={'row my-3'}>
                            <div className={'col-12 col-lg-4'}>
                                <div style={{ overflowX: 'auto' }}>
                                    <table className={'my-3 key-metrics-table table table-borderless table-sm no-footer'}>
                                        <tbody>
                                            <tr className="text-blue bg-white">
                                                <th colSpan={2}>{$t('Broadcast Reach')}</th>
                                            </tr>
                                            <tr className="bg-white">
                                                <td className={'text-gray'}>{$t('Average TV audience')}</td>
                                                <td className={'font-weight-bold text-right text-blue'}>
                                                    {props.format(props.data.broadcast_reach.average_tv_audience)}
                                                </td>
                                            </tr>
                                            <tr className="bg-white">
                                                <td className={'text-gray'}>{$t('Peak Audience')}</td>
                                                <td className={'font-weight-bold text-right text-blue'}>
                                                    {props.format(props.data.broadcast_reach.peak_audience)}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className={'col-12 col-lg-8'}>
                                <div className={'row h-100 align-items-start'}>
                                    <div className={'col-12 col-lg-6'}>
                                        <div className="card border-0 rounded-15px bg-white shadow">
                                            <div className="card-body card-widget">
                                                <div className={'d-flex flex-column justify-content-center h-100 p-3'}>
                                                    <h4 className={'text-blue mb-2'}>{$t('Total Social Reach')}</h4>
                                                    <h3 className={'text-blue'}>{props.format(props.data.total_social_reach)}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'col-12 col-lg-6'}>
                                        <div className="card border-0 rounded-15px bg-white shadow">
                                            <div className="card-body card-widget">
                                                <div className={'d-flex flex-column justify-content-center h-100 p-3'}>
                                                    <h4 className={'text-blue mb-2'}>{$t('Total Broadcast Reach')}</h4>
                                                    <h3 className={'text-blue'}>{props.format(props.data.total_broadcast_reach)}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
